'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

var _reject2 = require('lodash/reject');

var _reject3 = _interopRequireDefault(_reject2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.isLoadTime = isLoadTime;
exports.needReloadProjects = needReloadProjects;
exports.loadProjects = loadProjects;
exports.reorder = reorder;
exports.filter = filter;
exports.deleteProject = deleteProject;
exports.setProjectsListPage = setProjectsListPage;

var _loadReducer = require('../loadReducer');

var _loadReducer2 = _interopRequireDefault(_loadReducer);

var _projects = require('helpers/projects');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Projects redux reducer and action creators */

var ORDER = 'projects/ORDER';
var FILTER = 'projects/FILTER';
var NEED_RELOAD = 'projects/NEED_RELOAD';
var SET_PROJECTS_LIST_PAGE = 'projects/SET_PROJECTS_LIST_PAGE';

var loadReducer = (0, _loadReducer2.default)('projects', {
  projects: {
    action: 'load',
    init: { newsletters: [], sharespace: [], audio: [], video: [] },
    fields: {
      newsletters: 'listNewsletters',
      sharespace: 'listOfMasterProject',
      audio: 'listOfAudioProjects',
      video: 'listOfVideoProjects'
    }
  },
  deleteProject: { loaderKeys: ['projectId'] }
});

var initialState = (0, _extends5.default)({}, loadReducer.initialState, {
  order: {
    id: 'desc',
    fullTitle: 'asc',
    owName: 'asc',
    statusText: 'asc',
    iRef: 'asc'
  },
  activeOrder: 'id',
  kw: '',
  projectsListPage: 1
});

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'RESET':
      return initialState;
    case ORDER:
      return (0, _extends5.default)({}, state, {
        order: (0, _extends5.default)({}, state.order, (0, _defineProperty3.default)({}, action.name, state.activeOrder === action.name ? state.order[action.name] === 'asc' ? 'desc' : 'asc' : state.order[action.name])),
        activeOrder: action.name
      });
    case FILTER:
      return (0, _extends5.default)({}, state, {
        kw: action.kw,
        projectsListPage: 1
      });
    case NEED_RELOAD:
      return (0, _extends5.default)({}, state, {
        loaded: false
      });
    case SET_PROJECTS_LIST_PAGE:
      return (0, _extends5.default)({}, state, {
        projectsListPage: action.page
      });
    case loadReducer.constants.DELETE_PROJECT_SUCCESS:
      {
        var projectType = action.projectType,
            projectId = action.projectId;

        var projects = state.projectsData[projectType];
        return (0, _extends5.default)({}, loadReducer.reducer(state, action), {
          projectsData: (0, _extends5.default)({}, state.projectsData, (0, _defineProperty3.default)({}, projectType, (0, _reject3.default)(projects, { id: projectId })))
        });
      }
    default:
      return loadReducer.reducer(state, action);
  }
}

function isLoaded(globalState) {
  return (0, _get3.default)(globalState, 'projects.loaded', false);
}

function isLoadTime(globalState) {
  return (/*!isLoaded(globalState) && */(0, _get3.default)(globalState, 'auth.user', false)
  );
}

function needReloadProjects() {
  return {
    type: NEED_RELOAD
  };
}

function loadProjects() {
  return {
    types: loadReducer.constantsByKey.projects,
    promise: function promise(client) {
      var result = client.post('project_wa/getList');
      result.promise.then(_projects.transformProjectsResponse);
      return result;
    },
    abortable: true
  };
}

function reorder(name) {
  return {
    type: ORDER,
    name: name
  };
}

function filter() {
  var kw = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: FILTER,
    kw: kw
  };
}

function deleteProject(projectId, projectType) {
  return {
    types: loadReducer.constantsByKey.deleteProject,
    promise: function promise(client) {
      return client.post('project_wa/deleteProject', { data: { projectId: projectId } });
    },
    projectId: projectId,
    projectType: projectType
  };
}

function setProjectsListPage(_ref) {
  var page = _ref.page;

  return {
    type: SET_PROJECTS_LIST_PAGE,
    page: page
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/projects.js
// module id = 359
// module chunks = 1